
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SupaEvent {
  id: string;
  slug: string;
  quarter: string;
  type: string;
  description: string | null;
  average: number | null;
  fabric_json1: any | null;
  fabric_json2: any | null;
  created_at: string;
}

interface SupaEventsState {
  events: SupaEvent[];
  loading: boolean;
  error: string | null;
}

const initialState: SupaEventsState = {
  events: [],
  loading: false,
  error: null
};

const supaEventsSlice = createSlice({
  name: 'supaEvents',
  initialState,
  reducers: {
    setSupaEvents: (state, action: PayloadAction<SupaEvent[]>) => {
      state.events = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    }
  }
});

export const { setSupaEvents, setLoading, setError } = supaEventsSlice.actions;
export default supaEventsSlice.reducer;
